// ================================================================
// src/data/freeStudyData.js
// دیتای دوره‌های مطالعه آزاد — نسخه‌ی پرداخت‌محور (v2)
// ================================================================

// 🆕 برای پشتیبانی از دوره‌های داینامیک
import dataEngine from '../core/books/data.js';
import { FILE_API } from '../core/books/apiClient.js';

/**
 * 🆕 تبدیل blobId سرور به URL کامل قابل نمایش
 * - اگر blobId با /media/ شروع شود → FILE_API + blobId
 * - اگر URL کامل باشد (http…) یا مسیر محلی (/) → همان
 */
export function resolveImageUrl(url) {
  if (!url) return '';
  if (typeof url !== 'string') return '';
  if (url.startsWith('/media/')) {
    return `${FILE_API}${url}`;
  }
  return url;
}

export const FREE_STUDY_GROUPS = [
  // ============================================================
  // 🗣️ گروه ۱: آموزش زبان‌ها
  // ============================================================
  /*{
    id: 1,
    title: '🗣️ آموزش زبان‌ها',
    courses: [
      {
        id: 'english-beginner',
        title: 'آموزش زبان انگلیسی',
        subtitle: 'از صفر تا مکالمه روزمره',
        image: '/Books/farsi-3.jpg',
        category: 'زبان',
        level: 'مقدماتی',
        instructor: 'استاد محمدی',
        instructorImage: '/FreeStudy/teachers/mohammadi.jpg',
        description:
          'در این دوره از صفر شروع می‌کنیم و با تکنیک‌های ساده و کاربردی، مکالمه روزمره انگلیسی را یاد می‌گیریم.',
        tags: ['انگلیسی', 'مکالمه', 'مقدماتی', 'کاربردی'],
        color: '#4f46e5',
        currency: 'IRT',
        pricing: {
          fullCoursePrice: 250000, // قیمت بسته‌ی کل دوره
        },
        videos: [
          {
            id: 'en-01-alphabet',
            title: 'درس ۱: آشنایی با الفبا',
            url: '/videos/riazi2.mp4',
            duration: 12,
            description: 'الفبای انگلیسی و تلفظ صحیح حروف',
            thumbnail: '/FreeStudy/english/thumb-01.jpg',
            price: 60000,
            isFree: true, // اولین ویدیو رایگان
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'en-02-greetings',
            title: 'درس ۲: احوالپرسی روزمره',
            url: '/videos/english/02-greetings.mp4',
            duration: 15,
            description: 'Hello, Good morning, How are you و ...',
            thumbnail: '',
            price: 60000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'en-03-introduce',
            title: 'درس ۳: معرفی خود',
            url: '/videos/english/03-introduce.mp4',
            duration: 18,
            description: 'My name is..., I am from...',
            thumbnail: '',
            price: 60000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'en-04-numbers-colors',
            title: 'درس ۴: اعداد و رنگ‌ها',
            url: '/videos/english/04-numbers-colors.mp4',
            duration: 14,
            description: 'One to ten, red, blue, green, ...',
            thumbnail: '',
            price: 60000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'en-05-restaurant',
            title: 'درس ۵: مکالمه در رستوران',
            url: '/videos/english/05-restaurant.mp4',
            duration: 20,
            description: 'سفارش غذا، منو، پرداخت',
            thumbnail: '',
            price: 60000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
        ],
      },
    ],
  },

  // ============================================================
  // 💻 گروه ۲: برنامه‌نویسی
  // ============================================================
  {
    id: 2,
    title: '💻 برنامه‌نویسی',
    courses: [
      {
        id: 'python-basics',
        title: 'آموزش برنامه‌نویسی پایتون',
        subtitle: 'اولین قدم به دنیای کد',
        image: '/FreeStudy/python.jpg',
        category: 'برنامه‌نویسی',
        level: 'مقدماتی',
        instructor: 'مهندس رضایی',
        description:
          'پایتون ساده‌ترین زبان برای شروع برنامه‌نویسی است. با مفاهیم پایه، متغیرها، شرط‌ها و حلقه‌ها آشنا می‌شوید.',
        tags: ['پایتون', 'برنامه‌نویسی', 'کدنویسی'],
        color: '#0891b2',
        currency: 'IRT',
        pricing: {
          fullCoursePrice: 220000,
        },
        videos: [
          {
            id: 'py-01-intro',
            title: 'جلسه ۱: پایتون چیست؟',
            url: '/videos/python/01-intro.mp4',
            duration: 10,
            description: 'معرفی زبان و نصب Python',
            thumbnail: '',
            price: 70000,
            isFree: true,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'py-02-variables',
            title: 'جلسه ۲: متغیرها',
            url: '/videos/python/02-variables.mp4',
            duration: 16,
            description: 'انواع داده و تعریف متغیر',
            thumbnail: '',
            price: 70000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'py-03-conditions',
            title: 'جلسه ۳: شرط‌ها',
            url: '/videos/python/03-conditions.mp4',
            duration: 20,
            description: 'if, elif, else',
            thumbnail: '',
            price: 70000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'py-04-loops',
            title: 'جلسه ۴: حلقه‌ها',
            url: '/videos/python/04-loops.mp4',
            duration: 22,
            description: 'for, while',
            thumbnail: '',
            price: 70000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
        ],
      },
    ],
  },

  // ============================================================
  // 🎨 گروه ۳: هنر و خلاقیت
  // ============================================================
  {
    id: 3,
    title: '🎨 هنر و خلاقیت',
    courses: [
      {
        id: 'slime-making',
        title: 'ساخت اسلایم رنگی',
        subtitle: 'هنر و علم در خانه',
        image: '/FreeStudy/slime.jpg',
        category: 'هنر و خلاقیت',
        level: 'آسان',
        instructor: 'خانم کریمی',
        description:
          'با مواد ساده‌ی خانگی، اسلایم‌های رنگی، براق و خوشمزه (!) درست کن.',
        tags: ['هنر', 'خلاقیت', 'سرگرمی', 'دست‌سازه'],
        color: '#ec4899',
        currency: 'IRT',
        pricing: {
          fullCoursePrice: 120000,
        },
        videos: [
          {
            id: 'sl-01-materials',
            title: 'قسمت ۱: مواد لازم',
            url: '/videos/slime/01-materials.mp4',
            duration: 8,
            description: 'چسب، بوراکس، رنگ خوراکی و ...',
            thumbnail: '',
            price: 50000,
            isFree: true,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'sl-02-mixing',
            title: 'قسمت ۲: ترکیب اصلی',
            url: '/videos/slime/02-mixing.mp4',
            duration: 12,
            description: 'مرحله به مرحله ساخت اسلایم',
            thumbnail: '',
            price: 50000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
          {
            id: 'sl-03-colors',
            title: 'قسمت ۳: ترفندهای رنگی',
            url: '/videos/slime/03-colors.mp4',
            duration: 15,
            description: 'اسلایم گالاکسی، کهکشانی، براق',
            thumbnail: '',
            price: 50000,
            isFree: false,
            isPreview: false,
            previewSeconds: 0,
          },
        ],
      },
    ],
  },*/
];

// ================================================================
// توابع کمکی
// ================================================================
export const getFreeStudyCourse = (courseId) => {
  // ۱. static (سازگاری کامل با قبل)
  for (const group of FREE_STUDY_GROUPS) {
    const found = group.courses.find((c) => c.id === courseId);
    if (found) return found;
  }

  // ۲. dynamic (از dataEngine)
  try {
    const project = dataEngine.project.get(courseId);
    if (
      project &&
      project.type === 'freeStudy' &&
      project.state === 'published' &&
      project.publishedVersionId
    ) {
      const version = dataEngine.version.get(project.publishedVersionId);
      const teacher = project.teacherId
        ? dataEngine.teacher.get(project.teacherId)
        : null;
      return projectToCourse(project, version, teacher);
    }
  } catch (e) {
    console.warn('[getFreeStudyCourse] dynamic load failed:', e);
  }

  return null;
};

/**
 * 🆕 تبدیل Project Data Model → Course Shape
 * ساختار خروجی دقیقاً همان ساختاری است که FreeStudyCourse.jsx انتظار دارد
 */
export function projectToCourse(project, version, teacher) {
  if (!project) return null;

  const videos = (version?.videos || []).map((v, idx) => ({
    id: v._id,
    title: v.title || `ویدیوی ${idx + 1}`,
    url: resolveImageUrl(v.blobId || v.externalUrl || ''),
    duration: Number(v.durationMinutes) || 0,
    description: v.description || '',
    thumbnail: resolveImageUrl(v.thumbnailBlobId || ''),
    price: Number(v.price) || 0,
    isFree: v.isFree === true,
    isPreview: false,
    previewSeconds: 0,
  }));

  return {
    id: project.id,
    title: project.title,
    subtitle: project.subtitle || '',
    image: resolveImageUrl(project.image || project.coverImageBlobId || ''),
    category: project.category || 'سایر',
    level: project.level || 'مقدماتی',
    instructor: teacher?.fullName || 'معلم',
    instructorImage: resolveImageUrl(
      teacher?.avatarBlobId || teacher?.legacyAvatar || ''
    ),
    description: project.description || '',
    tags: Array.isArray(project.tags) ? project.tags : [],
    color: project.color || '#4f46e5',
    currency: project.currency || 'IRT',
    pricing: {
      fullCoursePrice: Number(project.fullCoursePrice) || 0,
    },
    videos,
    _isDynamic: true,
    _projectId: project.id,
  };
}

/**
 * 🆕 بخش‌های داینامیک برای نمایش در Books.jsx
 * دوره‌های منتشرشده، گروه‌بندی‌شده بر اساس category
 */
export function getDynamicFreeStudySections() {
  try {
    const projects = dataEngine.project.list({
      type: 'freeStudy',
      state: 'published',
    });
    if (projects.length === 0) return [];

    // 🆕 خواندن دسته‌بندی‌های تعریف‌شده توسط مدیر
    let categories = [];
    try {
      categories = dataEngine.category?.list() || [];
    } catch {
      categories = [];
    }
    const catById = new Map(categories.map((c) => [c.id, c]));
    const catByName = new Map(categories.map((c) => [c.name, c]));

    // گروه‌بندی پروژه‌ها بر اساس categoryId (یا نام به‌عنوان fallback)
    const groups = new Map(); // key → { name, sortIndex, projects: [] }

    for (const project of projects) {
      const cid = project.categoryId;
      const catObj = cid ? catById.get(cid) : null;
      const fallbackByName = !catObj ? catByName.get(project.category) : null;
      const resolved = catObj || fallbackByName;

      let key, displayName, sortIndex;
      if (resolved) {
        key = `cat:${resolved.id}`;
        displayName = resolved.name;
        sortIndex = Number(resolved.sortIndex) || 0;
      } else {
        const name = (project.category || '').trim() || 'سایر';
        key = `raw:${name}`;
        displayName = name;
        // پروژه‌های یتیم بعد از همه‌ی دسته‌بندی‌های رسمی می‌آیند
        sortIndex = 9999;
      }

      if (!groups.has(key)) {
        groups.set(key, { name: displayName, sortIndex, projects: [] });
      }
      groups.get(key).projects.push(project);
    }

    // 🆕 مرتب‌سازی بر اساس sortIndex مدیر
    const orderedGroups = Array.from(groups.values())
      .sort((a, b) => {
        if (a.sortIndex !== b.sortIndex) return a.sortIndex - b.sortIndex;
        return a.name.localeCompare(b.name, 'fa');
      });

    const sections = [];
    let sectionId = 1000;

    for (const group of orderedGroups) {
      sections.push({
        id: sectionId++,
        title: `🎯 ${group.name}`,
        _isDynamic: true,
        items: group.projects.map((p) => {
          const version = p.publishedVersionId
            ? dataEngine.version.get(p.publishedVersionId)
            : null;
          const videos = version?.videos || [];
          const totalMin = videos.reduce(
            (s, v) => s + (Number(v.durationMinutes) || 0),
            0
          );
          return {
            id: p.id,
            title: p.title,
            image: resolveImageUrl(p.image || p.coverImageBlobId || ''),
            duration: _formatTotalMinutes(totalMin),
            studentsCount: 0,
            progress: 0,
            link: `/free-study/${p.id}`,
            isFreeStudy: true,
            courseId: p.id,
            totalVideos: videos.length,
          };
        }),
      });
    }

    return sections;
  } catch (e) {
    console.warn('[getDynamicFreeStudySections] failed:', e);
    return [];
  }
}

// 🆕 helper داخلی
function _formatTotalMinutes(total) {
  if (!total || total <= 0) return '—';
  if (total < 60) return `${total} دقیقه`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m === 0 ? `${h} ساعت` : `${h}:${String(m).padStart(2, '0')} ساعت`;
}

export const getAllFreeStudyCourses = () =>
  FREE_STUDY_GROUPS.flatMap((g) => g.courses);

// ✅ کمک برای ادمین: تولید id یونیک برای ویدیوی جدید
export const generateVideoId = (courseId, order, title = '') => {
  const prefix = courseId.split('-')[0].slice(0, 3);
  const slug = (title || '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .slice(0, 20);
  return `${prefix}-${String(order).padStart(2, '0')}-${slug || 'video'}`;
};